import clsx from 'clsx'
import React from 'react'

import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import {
  getNonGeneralWidgetUrl,
  NON_GENERAL_WIDGET,
  trackWidgetClick,
} from './utils'

import { Anchor } from 'components/Anchor'

import type { IModule } from './typings'

const BaseWidget = React.forwardRef<
  HTMLDivElement,
  IModule & { className?: string }
>(
  (
    {
      title,
      duration,
      materiAmount,
      className,
      id,
      topicId,
      topicName,
      trackerWidgetData,
    },
    ref
  ) => {
    const url = getNonGeneralWidgetUrl({
      type: NON_GENERAL_WIDGET.Module,
      id,
      topicId,
      topicName,
    })
    return (
      <Anchor href={url!}>
        <a href={url!} className="mb-2 last:mb-0 block">
          <div
            className={clsx(
              'rounded border border-subdued p-3',
              'cursor-pointer',
              className
            )}
            ref={ref}
            onClick={() =>
              trackWidgetClick({
                ...trackerWidgetData,
                widgetValue: {
                  ...trackerWidgetData.widgetValue,
                  url,
                },
              })
            }
          >
            <div>
              <Text className="mb-[2px]" variant="body-sm">
                Modul
              </Text>
              <Text className="mb-[2px] line-clamp-2" variant="heading-sm">
                {title}
              </Text>
              <div className="grid align-middle mt-1 grid-cols-[100px_1fr]">
                <Text
                  color="subdued"
                  variant="body-sm"
                  className="mb-0 flex items-center"
                >
                  <Icon
                    as="i"
                    color="default"
                    style={{ fontSize: '16px' }}
                    fontSize="sm"
                    className="mr-1"
                  >
                    access_time
                  </Icon>
                  {duration} menit
                </Text>
                <Text
                  color="subdued"
                  variant="body-sm"
                  className="mb-0 flex items-center"
                >
                  <Icon
                    as="i"
                    color="default"
                    style={{ fontSize: '16px' }}
                    fontSize="sm"
                    className="mr-1"
                  >
                    book
                  </Icon>
                  {materiAmount} materi
                </Text>
              </div>
            </div>
          </div>
        </a>
      </Anchor>
    )
  }
)
BaseWidget.displayName = 'Module'

export default BaseWidget
